module.exports = {
    bindings: {
        expanded: '@',
        noteId: '@',
        item: '<'
    },
    controller: annotationNavItemController,
    templateUrl: 'texts/components/annotation-nav-item.html'
};

annotationNavItemController.$inject = ['annotationsNavigationService'];

function annotationNavItemController(annotationsNavigationService) {

    var vm = {
        clickNavItem: clickNavItem,
    };

    function clickNavItem(item) {
        annotationsNavigationService.scrollToItemByXpath(item, vm.noteId);
    }

    return vm;
}
